// A number that can be changed against a real deploy without a rebuild, so the tuning that only
// shows up on a contributor's own machine and connection can be A/B-tested where it matters.
//
// Set it from the URL (?uploadConcurrency=2) or from the console:
//   localStorage.setItem("crowd.uploadConcurrency", "2")
// Persisting the query parameter means it survives the navigation into the job page.
// Read on every use rather than captured once, so a value set from the console takes effect on the
// next upload instead of on the next reload. Promoting the query parameter is the one part that
// only needs doing once — it is a write, and these are read from inside semaphores.
const promoted = new Set();

export default function runtimeOverride({ queryKey, storageKey, fallback, max }) {
    try {
        if (!promoted.has(queryKey)) {
            promoted.add(queryKey);
            const fromQuery = new URLSearchParams(window.location.search).get(queryKey);
            if (fromQuery) {
                localStorage.setItem(storageKey, fromQuery);
            }
        }
        const override = Number(localStorage.getItem(storageKey));
        if (Number.isFinite(override) && override >= 1) {
            return Math.min(max, Math.floor(override));
        }
    }
    catch (e) {
        console.warn(`Could not read the ${storageKey} override; using the default.`, e);
    }
    return fallback;
}
